import { defineStore } from 'pinia'
import { simple } from '@/api/home/index'
import router from '@/router'
import { removeLocalCache } from '@/utils/cache'
import { useEnvStore } from '@/stores'

export const useUserInfoStore = defineStore(
  'userInfo',
  () => {
    const initialized = ref(false)
    const userData = ref(null)
    const initializing = ref(false)

    const simpleApi = async () => {
      initializing.value = true
      try {
        const res = await simple()
        initialized.value = true
        let { data } = res
        localStorage.setItem('userInfo', JSON.stringify({ userData: data }))
        userData.value = data
        const envStore = useEnvStore()
        if (!data || data.promoterStatus == 100) {
          // 首次进入
          if (envStore.isWeb()) {
            // 代理指南
            router.push('/guide')
          } else {
            // 代理
            router.push('/poster')
          }
        } else if ([1, 2, 99].includes(data.promoterStatus)) {
          if (data.promoterStatus == 99) {
            if (data.agreement === 1 || data.agreement === 2) {
              // 待审核/驳回
              router.push('/review')
            } else if (data.agreement === 0) {
              // 通过、默认都是0
              router.push('/certification')
            }
          } else {
            // 申请表单
            router.push('/certification')
          }
        } else if ([0, 3].includes(data.promoterStatus)) {
          // 个人中心
          // router.push('/home')
        }
      } finally {
        initializing.value = false
      }
    }

    const setUserData = (data) => {
      userData.value = data
    }

    const getInitialized = () => {
      return initialized.value
    }

    const getUserData = () => {
      return userData.value
    }

    const initialize = async () => {
      if (initialized.value || initializing.value) return
      await simpleApi()
    }

    const removeAll = () => {
      initialized.value = false
      userData.value = null
      removeLocalCache('userData')
    }

    return {
      userData,
      simpleApi,
      initialize,
      getUserData,
      getInitialized,
      setUserData,
      removeAll,
    }
  },
  {
    // 添加持久化配置
    persist: true,
  },
)
